const SIDEBAR_COLLAPSE_LOCAL_STORAGE_KEY = 'sidebar-is-collapsed';

export {
  SIDEBAR_COLLAPSE_LOCAL_STORAGE_KEY,
};
